<template>
  <div id="BannerTable">
    <b-table
      v-if="banners"
      striped
      hoverable
      :data="banners"
      @click="navigateToBannerDetail"
      style="cursor: pointer;"
    >
      <template slot-scope="props">
        <b-table-column field="date" label="Date">
          {{ props.row.create_date | dateformatter }}
        </b-table-column>

        <b-table-column field="image" label="Image">
          <figure class="image is-128x128">
            <img class="cover-center" :src="props.row.cover_image" />
          </figure>
        </b-table-column>

        <b-table-column field="title" label="Title">
          <div class="columns is-multiline">
            <div class="column is-12">
              {{ props.row.title.en }}
            </div>
          </div>
        </b-table-column>

        <b-table-column field="subtitle" label="Sub Title">
          <div class="columns is-multiline">
            <div class="column is-12">
              {{ props.row.sub_title.en }}
            </div>
          </div>
        </b-table-column>

        <b-table-column field="type" label="Type" centered>
          <span v-if="props.row.type === 'cover'" class="tag is-success">
            <b>Cover</b>
          </span>
          <span v-else-if="props.row.type === 'news'" class="tag is-info">
            <b>News</b>
          </span>
          <span v-else-if="props.row.type === 'product'" class="tag is-warning">
            <b>Product</b>
          </span>
          <span v-else class="tag is-danger">
            {{ props.row.type }}
          </span>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import Helpers from "@/utils/Helpers";
import BannerApi from "@/apis/BannerApi";

export default {
  name: "BannerTable",
  data() {
    return {
      banners: null
    };
  },
  filters: {
    dateformatter: function(value) {
      if (!value) return "";
      return Helpers.dateFormatter(value);
    }
  },
  methods: {
    getBannerList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await BannerApi.requestBannerList();
      loadingComponent.close();
      if (response && response.length > 0) {
        this.banners = response;
      }
    },
    navigateToBannerDetail: function(selectedBanner) {
      this.$router.push({
        name: "banner-detail",
        params: { banner: selectedBanner }
      });
    }
  },
  mounted() {
    this.getBannerList();
  }
};
</script>

<style scoped>
.cover-center {
  object-position: center;
  object-fit: cover;
  height: 128px;
}
.clickable-icon {
  cursor: pointer;
  margin-right: 0.5rem;
}
</style>
